module.exports = __webpack_public_path__ + "9b9bf019b4899e2027bbff8c0c6e0ad0.svg";